module.exports = __webpack_public_path__ + "img/videobgc2.c81300d8.png";